// extracted by mini-css-extract-plugin
module.exports = {"container":"Pill_container__wd_pV","textContainer":"Pill_textContainer__ZMLrO"};